export function numberToFixed (number, digit, isPercentage) {
  if (!number || Number.isInteger(number)) {
    return number
  } else if (isPercentage) {
    return (number.toString()?.match(/^-?\d+(?:\.\d{0,2})?/)[0] ?? '0')
  } else {
    return (parseInt(number * 10 * digit) / (10 * digit)).toFixed(digit)
  }
}
export function numberToFixedHalfAdjust (number, digit) {
  if (!number || Number.isInteger(number)) {
    return number
  } else {
    return number.toFixed(digit)
  }
}
